import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import Home from './components/pages/Home';
import Login from './components/pages/Login';
import SignUp from './components/pages/SignUp';
import UpdatedBook from './components/UpdatedBook';
import About from './components/pages/About';
import Upload from './components/Upload';
import ProtectedRoute from './context/ProtectedRoute';
import ErrorPage from './components/pages/ErrorPage';

function App() {
  return (
    <div className='App'>
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route
          path='/upload'
          element={
            <ProtectedRoute>
              <Upload />
            </ProtectedRoute>
          }
        />
        <Route path='/update/:id' element={<UpdatedBook />} />
        {/* <Route path='/update/:id' element={<ProtectedRoute><UpdatedBook /></ProtectedRoute>} /> */}
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<SignUp />} />
        <Route path='*' element={<ErrorPage />} />
      </Routes>
    </div>
  );
}

export default App;
